import * as React from 'react'

import DesktopListTable from '~/client/src/desktop/tables/DesktopListTable'
import type { UseTableListResult } from '~/client/src/desktop/tables/useTableList'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import type { IFormTypeRow } from '../types'

interface ITableProps {
  readonly list: UseTableListResult<IFormTypeRow>
}

export default function FormTypesTable({
  list,
}: ITableProps): React.ReactElement {
  return (
    <DesktopListTable
      list={list}
      ariaLabel={Localization.translator.workflows}
      fillContainerWidth
    />
  )
}
